import type { LabelHTMLAttributes, ReactNode } from "react";

import { cn } from "../lib/cn.js";

/**
 * A form label. Ported from the `.label` class this package replaced.
 *
 * shadcn/ui's label is `leading-none` with no margin, spaced by a wrapping flex column. This keeps
 * the bottom margin instead: the forms here are plain label/input pairs, and adding a wrapper to
 * every one of them purely to recover the gap would be worse than carrying it on the label.
 */

const LABEL = "mb-1.5 block text-sm leading-none font-medium text-muted select-none";

export type LabelProps = LabelHTMLAttributes<HTMLLabelElement>;

export function Label({ className, ...rest }: LabelProps): ReactNode {
  return <label className={cn(LABEL, className)} {...rest} />;
}
